/*
 * @Author: Chao Yang
 * @Date: 2019-12-12 01:18:30
 * @LastEditor: Chao Yang
 * @LastEditTime: 2020-05-06 13:41:45
 */
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { Injectable } from '@angular/core';

@Injectable()
export class ResultHandler implements HttpInterceptor {
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      map((event) => {
        if (event instanceof HttpResponse) {
          if (event.body && event.body.__chao) {
            if (event.body.success) {
              (event as any).body = event.body.result;
            } else {
              throw event.body.error;
            }
          }
        }
        return event;
      }),
      catchError((err, caught) => {
        if (err instanceof HttpErrorResponse) {
          if (err.status !== 401) {
            if (err.error && err.error.__chao === true) {
              return throwError(err.error.error);
            }
          } else {
            window.location.href =
              '/transferstation/investorportal?returnUrl=' +
              encodeURIComponent(window.location.href);
          }
        }
        return throwError(err);
      })
    );
  }
}
